module.exports = __webpack_public_path__ + "media/flags/ad-4e681826.svg";